/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function setLocation() {

    if (localStorage.getItem('chosenLocation') != '' && localStorage.getItem('chosenLocation') != undefined && localStorage.getItem('chosenLocation') != null) {

        var _data = null;

        $('.header__action-list--location-item').each(function(i, e) {
            if ($(e).data('zip') == localStorage.getItem('chosenLocation')) {
                _data = e;
            }
        });

        $('.header__action-list--location-chosen .city').html($(_data).find('[data-option-city]').data('option-city'));
        $('.header__action-list--location-chosen .zip').html($(_data).find('[data-option-zip]').data('option-zip'));
    }

}

function setNewLocation() {
    var _loc = $(this).data('zip');

    $('.header__action-list--location-chosen .city').html($(this).find('[data-option-city]').data('option-city'));
    $('.header__action-list--location-chosen .zip').html($(this).find('[data-option-zip]').data('option-zip'));

    localStorage.setItem('chosenLocation', _loc);
    localStorage.setItem('chosenLocationID', $(this).find('[data-option-city]').data('option-id'));

    openList();
    getLocation();
}

function getLocation() {

        var _product = $('.sd-items-count').data('handle');
        var _data = {
            "variant_id": _product,
            "current_location": localStorage.getItem('chosenLocationID'),
            "locations": [75956814128, 75956683056]
        }

  console.log(_data);

          $.ajaxSetup({
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
            }
        });


        // $.ajax('/apps/locations/locations', 
        // {
        //     dataType: 'json', // type of response data
        //     data: _data,
        //     success: function (data,status,xhr) {   // success callback function
        //         var _city = $('.header__action-list--location-chosen .city').html();

        //         $('.sd-items-count').html('• ' + data + ' in stock in ' + _city);
        //     },
        //     error: function (jqXhr, textStatus, errorMessage) { // error callback 
        //       console.log('w error');
        //         console.log(jqXhr);
        //       console.log(textStatus);
        //       console.log(errorMessage);
        //     }
        // });

}

function openList() {
    $('.header__action-list--location-chosen').toggleClass('active');
    $('.header__action-list--location-list').toggleClass('active');
}

function init() {
    
    if ($('.sd-items-count')) {

        $('.header__action-list--location-chosen').on('click', openList);
        $('.header__action-list--location-item').on('click', setNewLocation);
    
        setLocation();
        getLocation();
    }

}

$(document).ready(function() {
    init();
});
